
import { defineComponent, ref, onMounted, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import router from "@/router";
import ProductionStocks, {
  exportProductionStockData,
  exportPDFProductionStocks,
  getStockCountById,
} from "@/core/data/productionStock";
import {
  ProductionStock,
  getProductionStocks,
  deleteProductionStock,
} from "@/core/data/productionStock";
import { useRoute } from "vue-router";
import moment from "moment";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getUserById, getUsers } from "@/core/data/users";
import { getError } from "@/core/helpers/utils";

export default defineComponent({
  name: "ProductionStock-listing",
  components: {
    Datatable,
  },
  setup() {
    const route = useRoute();
    const stockCount = ref<any>({});
    const checkedProductionStock = ref([]);
    const selectedStatus = ref("");

    let selectedItem = ref({});
    const selectedMaterial = computed(() => {
      return route.params.id;
    });
    const total = ref<any>(0);
    const currentPage = ref<any>(1);
    const showSearchPanel = ref<boolean>(true);
    const selectAllProductionStock = ref<boolean>(false);
    const isLoading = ref<boolean>(true);
    const search = ref<string>("");
    const tableData = ref<Array<ProductionStock>>(ProductionStocks);
    const userList = ref<any>({});
    const searchData = ref<any>({});
    const userOptionList = ref<any>([]);
    const userIdList = ref<Array<any>>([]);
    const branch = ref([]);
    const course = ref([]);
    const universiteies = ref([]);
    const getListItems = function (pageNumber) {
      console.log("selectedMaterial.value", selectedMaterial.value);
      isLoading.value = true;
      if (pageNumber) {
        currentPage.value = pageNumber;
      }
      return new Promise((res, rej) => {
        getProductionStocks(
          currentPage.value,
          searchData.value,
          selectedStatus.value,
          selectedMaterial.value.toString()
        ).then((resObj: any) => {
          isLoading.value = false;
          total.value = resObj.count;
          tableData.value.splice(0, tableData.value.length, ...resObj.data);
          console.log("tableData", tableData.value);
          let promiseList: any = [];
          tableData.value.forEach((item) => {
            if (userIdList.value.indexOf(item.created_by) == -1) {
              userIdList.value.push(item.created_by);
              promiseList.push(getUserName(item.created_by));
            }
            Promise.all(promiseList).then(() => {
              res(resObj);
            });
          });
          console.log("tableData", tableData.value);
        });
      });
    };
    const getUserName = async function (id) {
      if (!userList.value[id]) {
        let userData = await getUserById(id);
        userList.value[id] = userData;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("ProductionStocks Listing", [
        "Apps",
        "ProductionStocks",
      ]);
      getListItems(1);
      getStockCountById(route.params.id).then(function (data: any) {
        console.log(data);
        stockCount.value = {
          in: data?.inQty?.qty__sum,
          out: data?.outQty?.qty__sum,
          waste: data?.wasteQty?.qty__sum,
        };
      });
    });

    const userListComputed = computed(() => {
      return [
        { id: "", name: "All" },
        ...userOptionList.value.map((item) => ({
          name: item.name,
          ...item,
        })),
      ];
    });

    const asyncUser = (query) => {
      console.log("query", query);
      getUsers(1, query).then((resObj: any) => {
        userOptionList.value.splice(
          0,
          userOptionList.value.length,
          ...resObj.data
        );
      });
    };
    const deleteFewSites = () => {
      checkedProductionStock.value.forEach((item) => {
        deleteProductionStock(item);
      });
      checkedProductionStock.value.length = 0;
    };
    const exportFewSites = () => {
      exportProductionStockData(
        selectAllProductionStock.value
          ? "all"
          : checkedProductionStock.value.join(",")
      ).then(() => {
        Swal.fire(
          "Export!",
          "Your ProductionStock has been exported.",
          "success"
        );
      });
    };
    const exportPDFProductionStocksHanlder = () => {
      exportPDFProductionStocks(
        selectAllProductionStock.value
          ? "all"
          : checkedProductionStock.value.join(",")
      ).then(() => {
        Swal.fire(
          "Export!",
          "Your ProductionStock has been exported.",
          "success"
        );
      });
    };
    const deleteProductionStockItem = (item) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteProductionStock(item)
            .then(() => {
              Swal.fire(
                "Deleted!",
                "Your ProductionStock has been deleted.",
                "success"
              );
              getListItems(currentPage.value);
            })
            .catch((err) => {
              Swal.fire({
                html: getError(err),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };
    const searchItems = () => {
      getListItems(1);
    };

    const setSelectedItem = (item) => {
      selectedItem.value = item;
    };

    const addProductionStock = (item) => {
      if (item.id) {
        router.push({
          name: "apps-stock-production-details",
          params: { id: selectedMaterial.value, stockId: item.id },
        });
      } else {
        router.push({ name: "apps-stock-production-add" });
      }
    };

    const onPageChange = (pageNumber) => {
      return getListItems(pageNumber);
    };

    const userData = computed(() => {
      return store.getters.currentUser;
    });

    const hasCreate = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasEdit = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasDelete = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const tableHeader = computed(() => {
      let columnsArr = [
        {
          name: " ",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "QTY",
          key: "qty",
          sortable: false,
        },
        {
          name: "Remark",
          key: "remark",
          sortable: false,
        },
        {
          name: "Type",
          key: "stock_type",
          sortable: false,
        },
        {
          name: "Material",
          key: "production_data",
          sortable: false,
        },
      ];
      if (hasEdit.value || hasDelete.value) {
        columnsArr.push({
          name: "Actions",
          key: "actions",
          sortable: false,
        });
      }
      return columnsArr;
    });

    const onClickBack = () => {
      router.back();
    };
    return {
      addProductionStock,
      setSelectedItem,
      selectedItem,
      tableData,
      tableHeader,
      deleteProductionStock,
      getProductionStocks,
      deleteProductionStockItem,
      search,
      searchItems,
      checkedProductionStock,
      deleteFewSites,
      moment,
      total,
      currentPage,
      isLoading,
      onPageChange,
      userData,
      hasCreate,
      hasEdit,
      hasDelete,
      selectedStatus,
      getUserName,
      userList,
      userListComputed,
      selectedMaterial,
      asyncUser,
      exportFewSites,
      exportPDFProductionStocksHanlder,
      selectAllProductionStock,
      showSearchPanel,
      searchData,
      branch,
      universiteies,
      course,
      onClickBack,
      stockCount,
    };
  },
});
